import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { Layout } from './components/common/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { UploadPage } from './pages/UploadPage';
import { IdeasPage } from './pages/IdeasPage';
import { ImageStudioPage } from './pages/ImageStudioPage';
import { LibraryPage } from './pages/LibraryPage';
import { ContentDetailPage } from './pages/ContentDetailPage';
import { ReviewPage } from './pages/ReviewPage';
import { SettingsPage } from './pages/SettingsPage';
import { UsersPage } from './pages/UsersPage';
import { LoginPage } from './pages/LoginPage';
import { SetupPage } from './pages/SetupPage';
import { LoadingSpinner } from './components/common/LoadingSpinner';
import { api } from './services/api';

export default function App() {
  const { isAuthenticated, isLoading, isCognitoConfigured, logout } = useAuth();

  // Wire up auth failure handler so 401s redirect to login
  useEffect(() => {
    api.setAuthFailureHandler(() => {
      logout();
    });
  }, [logout]);

  // Loading state while checking existing session
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-brand-cream">
        <LoadingSpinner size="lg" message="Checking session..." />
      </div>
    );
  }

  // Cognito not configured — show setup instructions instead of silently letting people in
  if (!isCognitoConfigured) {
    return <SetupPage />;
  }

  // Not authenticated — show login
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // Authenticated — show the app
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/ideas" element={<IdeasPage />} />
        <Route path="/images" element={<ImageStudioPage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/content/:id" element={<ContentDetailPage />} />
        <Route path="/review" element={<ReviewPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
